import { render, staticRenderFns } from "./xxy-sales-detail-board.vue?vue&type=template&id=64833ae7&scoped=true"
import script from "./xxy-sales-detail-board.vue?vue&type=script&lang=js"
export * from "./xxy-sales-detail-board.vue?vue&type=script&lang=js"
import style0 from "./xxy-sales-detail-board.vue?vue&type=style&index=0&id=64833ae7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64833ae7",
  null
  
)

export default component.exports